import CloseIcon from '@mui/icons-material/Close'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar'
import React, { SyntheticEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSnackbars, removeSnackbar } from '../store/snackbarSlice'

export default function SnackbarViewerComponent() {
  const dispatch = useDispatch()
  const snackbars = useSelector(getSnackbars) ?? []
  const handleClose =
    (id: string) =>
    (_: Event | SyntheticEvent, reason?: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return
      }
      dispatch(
        removeSnackbar({
          snackbarId: id,
        }),
      )
    }

  return (
    <>
      {snackbars.map((bar, index) => (
        <Snackbar
          key={bar.id}
          open={true}
          autoHideDuration={8000}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          className="print-hidden"
          onClose={handleClose(bar.id)}
          style={{
            bottom: `${index * 60 + 20}px`,
            transition: 'bottom 0.3s ease-out',
          }}
        >
          <Alert
            severity={bar.severity}
            variant="filled"
            sx={{ width: '100%', fontWeight: 'bold' }}
          >
            {bar.message}
            <Button
              color="secondary"
              style={{ height: '20px', color: 'white', minWidth: '20px' }}
              onClick={handleClose(bar.id)}
            >
              <CloseIcon />
            </Button>
          </Alert>
        </Snackbar>
      ))}
    </>
  )
}
